import React from "react";

import { AccordionItemProps, ActionItem, IconItems } from "../../components";
import { ovalIcon, rectangleIcon, trapezoidIcon } from "../../images";

export const toolPaletteTextBoxIds = ["MISC_TEXTBOX"] as const;
export type ToolPaletteTextBoxId = (typeof toolPaletteTextBoxIds)[number];

export const toolPaletteShadingIds = ["SHADING_RECTANGLE", "SHADING_OVAL", "SHADING_TRAPEZOID"] as const;
export type ToolPaletteShadingId = (typeof toolPaletteShadingIds)[number];

export const shadingItems: ActionItem<ToolPaletteShadingId>[] = [
  { id: "SHADING_RECTANGLE", label: "Rectangle", iconUrl: rectangleIcon },
  { id: "SHADING_OVAL", label: "Oval", iconUrl: ovalIcon },
  { id: "SHADING_TRAPEZOID", label: "Trapezoid", iconUrl: trapezoidIcon },
];

export const getGlobalToolPane = <TRadio extends string = string>(): AccordionItemProps<TRadio>[] => {
  return [{ type: "STANDARD", id: "shadings", label: "Shadings", bodyRender: <IconItems items={shadingItems} /> }];
};
